import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from '../../../../../Label';
import Button from '../../../../../Button';
import { CARD_ELEMENT_TYPE } from '../../../../../../../services/cards/constants';

const propTypes = {
  className: PropTypes.string,
  onCardElementCreate: PropTypes.func.isRequired,
  zElementIndexMax: PropTypes.number,
};

const CardDesignerBarCodeControls = ({
  className,
  onCardElementCreate,
  zElementIndexMax,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  const handleAddBarcode = () => {
    onCardElementCreate({
      cardElementType: CARD_ELEMENT_TYPE.BARCODE,
      cardElementConfiguration: {
        is_editable: true,
      },
      input: {
        frame: {
          x: 0.1,
          y: 0.775,
          width: 0.8,
          height: 0.2,
        },
        z_index: zElementIndexMax,
      },
    });
  };

  return (
    <div className={classes}>
      <Label id="barcode-control">ADD BARCODE</Label>
      <Button btnBlock btnStyle="primary" onClick={handleAddBarcode}>
        Add a barcode
      </Button>
      <p className="text-light text-xs mt-2">
        NOTE: The unique bar code for each ID card will be generated when the
        cards are generated and will utilize the Student / Staff ID associated
        with each cardholder.
      </p>
    </div>
  );
};

CardDesignerBarCodeControls.propTypes = propTypes;

export default CardDesignerBarCodeControls;
